import React from "react";
import { useNavigate } from "react-router-dom";
import { Row } from "@components/Flex";
import Button from "@components/Button";
import SizedBox from "@components/SizedBox";
import { ReactComponent as SignOutIcon } from "@assets/icons/signOut.svg";
import { observer } from "mobx-react-lite";
import { useLang } from "@src/hooks/useLang";
import { useStores } from "@stores";
import { ROUTES } from "@stores/AccountStore";

interface IProps {
  onLogOut: () => void;
}

const ProfileScreenHeadButtons: React.FC<IProps> = ({ onLogOut }) => {
  const lang = useLang();
  const navigate = useNavigate();
  const { accountStore } = useStores();
  const t = (lang as any).team ?? {};
  return (
    <Row justifyContent="flex-end">
      {accountStore.isViewingOwnAccount && (
        <>
          <Button
            onClick={() => navigate(ROUTES.TEAM)}
            kind="secondary"
            style={{ padding: "0 16px", maxWidth: "fit-content" }}
          >
            {t.title ?? "Team accounts"}
          </Button>
          <SizedBox width={8} />
        </>
      )}
      <Button
        onClick={onLogOut}
        kind="secondary"
        style={{ padding: "0 16px", maxWidth: "fit-content" }}
      >
        {lang.profile.exitButton}
        <SizedBox width={10} />
        <SignOutIcon />
      </Button>
    </Row>
  );
};

export default observer(ProfileScreenHeadButtons);
